const endpoint = "https://nmpb2.cuba-games.com"
const cpoint = "https://central-backend.cuba-lv.com"
const mediapoint = `${cpoint}`
const startpoint = `${cpoint}/`

const gamePlace = { studio: "bishkek", room: "po1-room" }

export { endpoint, mediapoint, startpoint, gamePlace }
